import { useProductSummaryName } from '../hooks/useProductSummaryName';

type NameContainerProps = { children: React.ReactNode };

const NameContainer = ({ children }: NameContainerProps) => {
	const { blockClass, componentId } = useProductSummaryName();

	return (
		<div
			data-selection={componentId}
			className={`nameContainer nameContainer--${blockClass} vtex-product-summary-2-x-nameContainer vtex-product-summary-2-x-nameContainer--${blockClass} flex items-start justify-center pv6`}
		>
			{children}
		</div>
	);
};

export default NameContainer;
